import { useState } from 'react'
import { useQuery } from 'react-query'
import { getAllTariffs } from '../services/report'

export default function useAllTariff() {
    const [tariffs, setTariffs] = useState([])

    const { refetch } = useQuery(['fetchTariffs'], () => getAllTariffs(), {
        enabled: true,
        retry: 2,
        onSuccess: (response) => {
            setTariffs(response?.data?.data)
        },
    })

    const getTariffs = () => {
        refetch()
    }

    return { tariffs, getTariffs}

}